module.exports = __webpack_public_path__ + "img/서브_패스킥슛.85fbd936.svg";